import { render, staticRenderFns } from "./project-details.vue?vue&type=template&id=ba2b7caa"
import script from "./project-details.vue?vue&type=script&lang=js"
export * from "./project-details.vue?vue&type=script&lang=js"
import style0 from "./project-details.vue?vue&type=style&index=0&id=ba2b7caa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports